import { combineReducers } from 'redux';
import user from './user';
import header from './header';
import subheader from './subheader';
import open_menu from './open_menu';
import sidebar from './sidebar';
import limited from './limited';
import request_plan from './request_plan';

export const reducer = combineReducers({
    user,
    header,
    subheader,
    open_menu,
    sidebar,
    limited,
    request_plan,
});

export type RootState = ReturnType<typeof reducer>;

export default reducer;